import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

const normalizeTags = (value) => {
  if (!value) return '';
  if (Array.isArray(value)) return value.join(', ');
  return String(value);
};

const ReportMetadataDialog = ({ open, report, onClose, onSave, saving }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [primaryKpi, setPrimaryKpi] = useState('');
  const [tags, setTags] = useState('');
  const [changeNote, setChangeNote] = useState('');

  useEffect(() => {
    if (!report) return;
    setName(report.name || '');
    setDescription(report.description || '');
    setPrimaryKpi(report.primaryKpi || '');
    setTags(normalizeTags(report.tags));
    setChangeNote('');
  }, [report]);

  const handleSave = () => {
    if (!report) return;
    const tagList = tags
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
    onSave({
      reportId: report.id,
      ifMatchVersion: report.version,
      metadata: {
        name,
        description,
        primaryKpi,
        tags: tagList,
      },
      changeNote,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit report metadata</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Report name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            size="small"
            fullWidth
          />
          <TextField
            label="Description"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            size="small"
            multiline
            minRows={2}
            fullWidth
          />
          <TextField
            label="Primary KPI"
            value={primaryKpi}
            onChange={(event) => setPrimaryKpi(event.target.value)}
            size="small"
            fullWidth
          />
          <TextField
            label="Tags (comma separated)"
            value={tags}
            onChange={(event) => setTags(event.target.value)}
            size="small"
            fullWidth
          />
          <TextField
            label="Change note"
            value={changeNote}
            onChange={(event) => setChangeNote(event.target.value)}
            size="small"
            fullWidth
            required
            helperText="Required for audit history."
          />
          <Typography variant="caption" color="text.secondary">
            Layout edits are API-only in Phase 2. This modal updates metadata only.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving || !changeNote.trim()}
        >
          Save changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportMetadataDialog;
